import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheet,
  MatBottomSheetModule,
} from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

const MODULES = [
  MatBottomSheetModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSlideToggleModule,
  MatExpansionModule,
  MatBottomSheetModule,
  MatRadioModule,
  MatInputModule,
  MatFormFieldModule,
  FormsModule,
  MatButtonModule,
  MatIconModule,
  MatButtonToggleModule,
];

@NgModule({
  exports: [MODULES],
  providers: [
    { provide: MatBottomSheet },
    { provide: MAT_BOTTOM_SHEET_DATA, useValue: {} },
  ],
})
export class MaterialModule {}
